module.exports = __webpack_public_path__ + "static/media/dks2805.7a8187d5.png";